import * as Y from "yjs";

// Minimal interface for the WebSocket provider — avoids circular import with CustomWebsocketProvider
interface WsProvider {
  ws: WebSocket | null;
  wsconnected: boolean;
  reconnect: () => void;
  verifyConnection: () => void;
}

class CustomDoc extends Y.Doc {
  public conns: Map<WebSocket, Set<number>>;
  public roomName: string;
  public name: string;
  private _wsProvider: WsProvider | null = null;

  constructor(guid: string, roomName: string) {
    super({ guid });
    this.conns = new Map();
    this.roomName = roomName;
    this.name = roomName; // Set the Y.Doc name property to match room name
  }

  setRoom(roomName: string) {
    if (this.roomName !== roomName) {
      console.log(`%c[CustomDoc] Updating room name from ${this.roomName} to ${roomName}`, 'color: #00ff00; font-weight: bold;');
      this.roomName = roomName;
      this.name = roomName; // Update the Y.Doc name property
    }
  }

  // Helper method to check if doc is for a specific room
  isForRoom(roomName: string): boolean {
    return this.roomName === roomName && this.name === roomName;
  }

  /**
   * Register the WebSocket provider with this doc.
   */
  registerProvider(provider: WsProvider): void {
    this._wsProvider = provider;
  }
}

export { CustomDoc };
